// @ts-nocheck
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
// components
import CheckoutForm, {STRIPE_ELEMENTS_CONFIG} from "../components/CheckoutForm";
import PageHeading from '../components/PageHeading';
// @interfaces
import { IQuote, IPurchase } from "../@interfaces/purchase.interface";
// styles
import styles from "../styles/pages/payment/PaymentPage.module.css";
import {IWidgetConfiguration} from "../merchantConfig";
import { sendAnalyticsEvent } from "../utils/analytics";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_CLIENT_ID);

interface PaymentPageProps {
  programmeCode?: string | null;
  clientSecret: string;
  quote: IQuote | null;
  setPurchase: (purchase: IPurchase) => void;
  setActiveStep: (step: number) => void;
  setUserEmail: (email: string) => void;
  onOffsetClick: (currency: string) => void;
  setEntryOptionSelected: (entryOptionSelected: boolean) => void;
  userEmail: string | null;
  appleGooglePayPaymentRequestData: any;
  merchantCode: string;
  language: string | null;
  widgetConfiguration: IWidgetConfiguration;
}

const PaymentPage: React.FC<PaymentPageProps> = ({
  programmeCode,
  clientSecret,
  quote,
  setPurchase,
  setActiveStep,
  merchantCode,
  language,
  setUserEmail,
  onOffsetClick,
  userEmail,
  appleGooglePayPaymentRequestData,
  setEntryOptionSelected,
  widgetConfiguration
}) => {
  const appearance = {
    theme: 'stripe',
  };
  const options = {
    clientSecret,
    appearance,
    ...STRIPE_ELEMENTS_CONFIG
  };

  const onCheckoutSuccess = (purchase: IPurchase) => {
    const purchaseData = {
      type: "POST_PURCHASE_OFFSET_RESULTS",
      payload: {
        offsetPrice: quote.offsetPrice,
        carbonOffsetQuantity: quote.carbonOffsetQuantity
      }
    };
    sendAnalyticsEvent('purchase', {
      co2Kgs: quote.carbonOffsetQuantity.value.toString(),
      itemName: "Contribution",
      price: quote.offsetPrice,
      transactionId: purchase.purchaseId
    });
    window.parent.postMessage(JSON.stringify(purchaseData), '*');
    setPurchase(purchase);
    setActiveStep(2);
  }

  return (
    <div className={`${styles.container} delayed-fadein`}>
      <PageHeading
        title={'Payment'}
        activeStep={1}
        setEntryOptionSelected={setEntryOptionSelected}
        setActiveStep={setActiveStep}
      />

      <div className={styles.marginTop}>
        <p className={styles.textBold}>{"Please enter your payment details."}</p>
      </div>

      <div style={{height: 'inherit'}}>
        {clientSecret && (
          <Elements options={options} stripe={stripePromise}>
            <CheckoutForm
              programmeCode={programmeCode}
              clientSecret={clientSecret}
              quote={quote}
              userEmail={userEmail}
              setUserEmail={setUserEmail}
              language={language}
              merchantCode={merchantCode}
              onCheckoutSuccess={onCheckoutSuccess}
              onOffsetClick={onOffsetClick}
              appleGooglePayPaymentRequestData={appleGooglePayPaymentRequestData}
              widgetConfiguration={widgetConfiguration}
            />
          </Elements>
        )}
      </div>
    </div>
  );
};

export default PaymentPage;
